// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter

/**
 * Fires when a user successfully creates an account
 */
export interface AccountCreated {
    email:            string;
    email_subscribe?: string;
    first_name:       string;
    join_date?:       Date;
    last_name:        string;
    phone?:           string;
    sms_subscribe?:   string;
    source?:          string;
    source_detail?:   string;
    [property: string]: any;
}

export interface AccountUpdated {
    email:            string;
    email_subscribe?: null | string;
    first_name:       string;
    last_name:        string;
    phone_number:     null | string;
    sms_subscribe?:   null | string;
    updated_fields:   UpdatedField[] | null;
    [property: string]: any;
}

export interface UpdatedField {
    field_name?:    string;
    field_value?:   string;
    update_action?: string;
    [property: string]: any;
}

export interface AffirmClicked {
    creative?:      string;
    list_name?:     string;
    position?:      string;
    site_campaign?: string;
    [property: string]: any;
}

export interface CTAClicked {
    affiliation?:  string;
    brand?:        string;
    cta_action?:   string;
    cta_header?:   string;
    cta_location?: string;
    cta_text?:     string;
    cta_type?:     string;
    link_url?:     null | string;
    [property: string]: any;
}

/**
 * Fires when a user views their cart
 */
export interface CartViewed {
    /**
     * Cart opened or closed
     */
    action:       string;
    basket_token: string;
    products:     CartViewedProduct[] | null;
    rec_strand?:  any[];
    [property: string]: any;
}

export interface CartViewedProduct {
    category:    string;
    description: string;
    discount?:   number;
    image_url:   string;
    name:        string;
    position:    number;
    price:       number;
    product_id:  string;
    quantity:    number;
    sku:         string;
    url:         string;
    variant?:    string;
    [property: string]: any;
}

/**
 * Fires on the page a user lands on after they select the checkout/proceed to checkout
 * button
 */
export interface CheckoutStarted {
    affiliation:  string;
    basket_token: string;
    brand:        string;
    coupon?:      null | string;
    currency:     string;
    discount?:    number | null;
    email?:       null | string;
    products:     CheckoutStartedProduct[];
    [property: string]: any;
}

export interface CheckoutStartedProduct {
    category:    string;
    description: string;
    discount?:   number;
    image_url:   string;
    name:        string;
    position:    number;
    price:       number;
    product_id:  string;
    quantity:    number;
    sku:         string;
    url:         string;
    variant?:    null | string;
    [property: string]: any;
}

/**
 * Fires when a user completes a checkout step in the checkout flow
 */
export interface CheckoutStepCompleted {
    basket_token:     string;
    email?:           string;
    email_subscribe?: null | string;
    first_name?:      null | string;
    join_date?:       null | string;
    last_name?:       null | string;
    phone?:           null | string;
    shipping_method?: null | string;
    /**
     * the checkout step completed
     */
    step?: number;
    [property: string]: any;
}

/**
 * Fires when a user views a step in the checkout flow
 */
export interface CheckoutStepViewed {
    basket_token:     string;
    email?:           null | string;
    first_name?:      null | string;
    last_name?:       null | string;
    shipping_method?: string;
    /**
     * checkout step viewed
     */
    step: number;
    [property: string]: any;
}

/**
 * Fires when the user interacts with the current cookie acceptance banner, e.g. accepts
 * all, disable all, or some cookie categories.
 */
export interface CookiePreferencesUpdated {
    /**
     * Describes the cookie categories the user is currently opted into, after any updates.
     */
    active_groups?: any;
    [property: string]: any;
}

/**
 * Fires when a coupon/promo code is applied to the order in the checkout flow
 */
export interface CouponApplied {
    /**
     * adfgadfgadfadsfasdf
     */
    basket_token: string;
    coupon_id:    string;
    coupon_name?: string;
    discount:     number;
    email:        string;
    first_name?:  string;
    last_name?:   string;
    [property: string]: any;
}

/**
 * Fires when the entered coupon/promo code is not applied to the order successfully
 */
export interface CouponDenied {
    basket_token: string;
    /**
     * coupon entered by user
     */
    coupon?: string;
    /**
     * Name of promotion associated with coupon
     */
    coupon_name?: string;
    email:        string;
    first_name:   string;
    last_name:    string;
    /**
     * Reason the coupon was denied
     */
    reason: string;
    [property: string]: any;
}

/**
 * Fires when a user removes a coupon/promo code from their order
 */
export interface CouponRemoved {
    basket_token: string;
    coupon_id?:   null | string;
    coupon_name?: string;
    discount?:    number;
    email?:       string;
    first_name?:  string;
    last_name?:   string;
    [property: string]: any;
}

/**
 * When a user calls a dealer
 */
export interface DealerCalled {
    /**
     * Whether or not the dealer offers assembly services // true, false
     */
    assembly_offered?: boolean | null;
    /**
     * The address of the dealer in your CMS or other system
     */
    dealer_address?: string;
    /**
     * The ID of the dealer in your CMS or other systen // X-ABC123
     */
    dealer_id?: string;
    /**
     * The name of the dealer in your CMS or other system // BBQ Supplies & More
     */
    dealer_name?: string;
    /**
     * Whether or not the dealer was open at the time of the event // true, false
     */
    dealer_open?: boolean;
    /**
     * The phone number of the dealer in your CMS or other system // +1 111-111-1111
     */
    dealer_phone?: string;
    /**
     * List of the Traeger products a dealer sells // ["timberline", "meater", "iornwood", "pro
     * series"]
     */
    dealer_products?: any[] | null;
    /**
     * The type of dealer in your CMS or other system // platinum, gold, silver, pellets,
     * military
     */
    dealer_type?: string;
    /**
     * Whether or not the dealer offers delivery services // true, false
     */
    delivery_offered?: boolean | null;
    /**
     * Whether or not the dealer offers in-store services // true, false
     */
    in_store_offered?: boolean | null;
    [property: string]: any;
}

/**
 * When a user clicks to view dealer details
 */
export interface DealerClicked {
    /**
     * Whether or not the dealer offers assembly services // true, false
     */
    assembly_offered?: boolean | null;
    /**
     * The address of the dealer in your CMS or other system
     */
    dealer_address?: string;
    /**
     * The ID of the dealer in your CMS or other systen // X-ABC123
     */
    dealer_id?: string;
    /**
     * The name of the dealer in your CMS or other system // BBQ Supplies & More
     */
    dealer_name?: string;
    /**
     * Whether or not the dealer was open at the time of the event // true, false
     */
    dealer_open?: boolean;
    /**
     * The phone number of the dealer in your CMS or other system // +1 111-111-1111
     */
    dealer_phone?: string;
    /**
     * List of the Traeger products a dealer sells // ["timberline", "meater", "iornwood", "pro
     * series"]
     */
    dealer_products?: any[] | null;
    /**
     * The type of dealer in your CMS or other system // platinum, gold, silver, pellets,
     * military
     */
    dealer_type?: string;
    /**
     * Whether or not the dealer offers delivery services // true, false
     */
    delivery_offered?: boolean | null;
    /**
     * Whether or not the dealer offers in-store services // true, false
     */
    in_store_offered?: boolean | null;
    /**
     * Position of product or recipe in the list
     */
    position?: string;
    [property: string]: any;
}

/**
 * When a user clicks a link for directions to the dealer
 */
export interface DealerDirections {
    /**
     * Whether or not the dealer offers assembly services // true, false
     */
    assembly_offered?: boolean | null;
    /**
     * The address of the dealer in your CMS or other system
     */
    dealer_address?: string;
    /**
     * The ID of the dealer in your CMS or other systen // X-ABC123
     */
    dealer_id?: string;
    /**
     * The name of the dealer in your CMS or other system // BBQ Supplies & More
     */
    dealer_name?: string;
    /**
     * Whether or not the dealer was open at the time of the event // true, false
     */
    dealer_open?: boolean;
    /**
     * The phone number of the dealer in your CMS or other system // +1 111-111-1111
     */
    dealer_phone?: string;
    /**
     * List of the Traeger products a dealer sells // ["timberline", "meater", "iornwood", "pro
     * series"]
     */
    dealer_products?: any[] | null;
    /**
     * The type of dealer in your CMS or other system // platinum, gold, silver, pellets,
     * military
     */
    dealer_type?: string;
    /**
     * Whether or not the dealer offers delivery services // true, false
     */
    delivery_offered?: boolean | null;
    /**
     * Whether or not the dealer offers in-store services // true, false
     */
    in_store_offered?: boolean | null;
    /**
     * The URL the link points to.
     */
    link_url?: string;
    [property: string]: any;
}

/**
 * When a user views a list of dealers
 */
export interface DealerListViewed {
    /**
     * An array of dealer objects
     */
    dealers?: Dealer[];
    /**
     * type of list being viewed (i.e. product, recipe, dealer)
     */
    list_id?: string;
    [property: string]: any;
}

export interface Dealer {
    /**
     * Whether or not the dealer offers assembly services // true, false
     */
    assembly_offered?: boolean | null;
    /**
     * The address of the dealer in your CMS or other system
     */
    dealer_address?: string;
    /**
     * The ID of the dealer in your CMS or other systen // X-ABC123
     */
    dealer_id?: string;
    /**
     * The name of the dealer in your CMS or other system // BBQ Supplies & More
     */
    dealer_name?: string;
    /**
     * Whether or not the dealer was open at the time of the event // true, false
     */
    dealer_open?: boolean;
    /**
     * The phone number of the dealer in your CMS or other system // +1 111-111-1111
     */
    dealer_phone?: string;
    /**
     * The type of dealer in your CMS or other system // platinum, gold, silver, pellets,
     * military
     */
    dealer_type?: string;
    /**
     * Whether or not the dealer offers delivery services // true, false
     */
    delivery_offered?: boolean | null;
    /**
     * Whether or not the dealer offers in-store services // true, false
     */
    in_store_offered?: boolean | null;
    /**
     * Position of product or recipe in the list
     */
    position?: number;
    [property: string]: any;
}

/**
 * Fires when a user clicks an email sent from Braze. Data coming from the Braze Currents
 * tool integration
 */
export interface EmailClicked {
    affiliation?:           string;
    brand?:                 string;
    braze_id?:              string;
    campaign_id?:           string;
    campaign_name?:         string;
    canvas_id?:             string;
    canvas_name?:           string;
    canvas_step_id?:        string;
    canvas_step_name?:      string;
    canvas_variation?:      string;
    canvas_variation_name?: string;
    dispatch_id?:           string;
    email?:                 string;
    external_user_id?:      string;
    id?:                    string;
    ip_pool?:               string;
    load_date?:             string;
    message_variation_id?:  string;
    modified_date?:         string;
    send_id?:               string;
    timezone?:              string;
    user_agent?:            string;
    [property: string]: any;
}

/**
 * Fires when a user opens an email sent from Braze. Data coming from the Braze Currents
 * tool integration
 */
export interface EmailOpened {
    braze_id?:              string;
    campaign_id:            string;
    campaign_name:          string;
    canvas_id?:             string;
    canvas_name?:           string;
    canvas_step_id?:        string;
    canvas_step_name?:      string;
    canvas_variation?:      string;
    canvas_variation_name?: string;
    dispatch_id:            string;
    email?:                 string;
    external_user_id?:      string;
    ip_pool?:               string;
    message_variation_id?:  string;
    modified_date?:         string;
    send_id?:               string;
    timezone?:              string;
    user_agent:             string;
    [property: string]: any;
}

/**
 * Fires when user successfully subscribes to email marketing either onsite or offsite
 */
export interface EmailSignupCompleted {
    email:               string;
    email_join_date:     string;
    email_source:        string;
    email_source_detail: string;
    email_subscribe?:    string;
    first_name?:         string;
    last_name?:          string;
    [property: string]: any;
}

/**
 * Fires when a user unsubscribes from an email sent from Braze. Data coming from the Braze
 * Currents tool integration
 */
export interface EmailUnsubscribed {
    affiliation?:           string;
    brand?:                 string;
    braze_id?:              string;
    campaign_id?:           string;
    campaign_name?:         string;
    canvas_id?:             string;
    canvas_name?:           string;
    canvas_step_id?:        string;
    canvas_step_name?:      string;
    canvas_variation?:      string;
    canvas_variation_name?: string;
    dispatch_id?:           string;
    email?:                 string;
    external_user_id?:      string;
    id?:                    string;
    ip_pool?:               string;
    load_date?:             string;
    message_variation_id?:  string;
    modified_date?:         string;
    send_id?:               string;
    timezone?:              string;
    user_agent?:            string;
    [property: string]: any;
}

/**
 * Fires when user successfully verifies their identity through ID.me
 */
export interface IDmeVerified {
    /**
     * The discount group of the user || ex: military, first responder, etc...
     */
    discount_group: string;
    /**
     * email address returned by ID.me
     */
    email: string;
    /**
     * The first name of the user returned by ID.me
     */
    first_name: string;
    /**
     * Unique ID returned by ID.me
     */
    idme_id: string;
    /**
     * The last name of the user returned by ID.me
     */
    last_name: string;
    /**
     * Zip code of the user returned by ID.me
     */
    zip_code?: null | string;
    [property: string]: any;
}

export interface LinkClicked {
    affiliation:   string;
    brand:         string;
    link_location: string;
    link_text:     string;
    link_type:     string;
    link_url:      string;
    [property: string]: any;
}

/**
 * Fires when the user clicks on a link in the top navigation OR footer
 */
export interface NavigationClicked {
    clicked_text:   string;
    email?:         string;
    first_name?:    string;
    last_name?:     string;
    link_location?: string;
    link_url?:      string;
    /**
     * Denotes if event occurred in top navigation or footer
     */
    nav_type:          string;
    primary_header:    string;
    secondary_header?: string;
    tertiary_header?:  string;
    [property: string]: any;
}

export interface NotifyMeClicked {
    category?:        string;
    description:      string;
    email?:           string;
    email_subscribe?: boolean;
    firstName?:       string;
    image_url:        string;
    lastName?:        string;
    list_name?:       string;
    name:             string;
    price:            number;
    product_id:       string;
    sku:              string;
    url:              string;
    variant:          string;
    [property: string]: any;
}

/**
 * Fires when a SKU, designated in a previous Notify Me Submitted event, is back in stock.
 * This event should prompt Braze to send the "back in stock" email to the customer
 */
export interface NotifyMeCompleted {
    category?:       null | string;
    description?:    string;
    email:           string;
    email_subscribe: string;
    first_name:      string;
    image_url:       string;
    last_name:       string;
    locale?:         string;
    name:            string;
    price:           number;
    product_id:      string;
    sku?:            string;
    url:             string;
    variant?:        string;
    [property: string]: any;
}

export interface NotifyMeSend {
    product?:                  { [key: string]: any };
    "product.locale"?:         string;
    "product.name"?:           string;
    "product.price"?:          number;
    "product.product_id"?:     string;
    traits?:                   { [key: string]: any };
    "traits.email"?:           string;
    "traits.email_subscribe"?: string;
    "traits.first_name"?:      string;
    "traits.last_name"?:       string;
    [property: string]: any;
}

/**
 * Fires when a SKU, designated in a previous Notify Me Submitted event, is back in stock.
 * This event should prompt Braze to send the "back in stock" email to the customer
 */
export interface NotifyMeSubmitted {
    category?:       null | string;
    description?:    string;
    email:           string;
    email_subscribe: null | string;
    first_name:      string;
    image_url:       string;
    last_name:       string;
    list_name?:      string;
    name:            string;
    price:           number;
    product_id:      string;
    sku?:            string;
    url:             string;
    variant?:        string;
    [property: string]: any;
}

/**
 * Fires when a user successfully completes their order
 */
export interface OrderCompleted {
    affiliation: string;
    /**
     * This value is for building a cart_url
     */
    basket_token?:     string;
    billing_address_1: string;
    billing_city:      string;
    billing_country:   string;
    billing_state:     string;
    billing_zip_code:  string;
    brand:             string;
    coupon?:           any[] | null;
    currency:          string;
    customer_group?:   any[] | null;
    discount:          number | null;
    email:             string;
    first_name:        string;
    ga_client_id?:     string;
    ga_session_id?:    string;
    last_name:         string;
    order_id:          string;
    payment_method:    any;
    phone:             string;
    products:          OrderCompletedProduct[];
    revenue:           number;
    shipping:          number;
    subtotal:          number;
    tax:               number;
    total:             number;
    [property: string]: any;
}

export interface OrderCompletedProduct {
    category:    string;
    description: string;
    discount:    number;
    image_url:   string;
    name:        string;
    position:    number;
    price:       number;
    product_id:  string;
    quantity:    number;
    sku:         string;
    url:         string;
    variant?:    null | string;
    [property: string]: any;
}

/**
 * Fires when a user views a page
 */
export interface PageViewed {
    category?:    string;
    content_row?: string;
    name:         string;
    path:         string;
    referrer?:    null | string;
    search?:      null | string;
    title:        string;
    url:          string;
    [property: string]: any;
}

/**
 * Fires when a user successfully enters payment information
 */
export interface PaymentInfoEntered {
    basket_token?:   string;
    email?:          string;
    first_name?:     string;
    last_name?:      string;
    payment_method?: string;
    [property: string]: any;
}

/**
 * Fires when a user adds an item to their cart
 */
export interface ProductAdded {
    affiliation:         string;
    basket_token:        string;
    brand:               string;
    category?:           string;
    coupon_name?:        any[] | null;
    currency:            string;
    description?:        string;
    essential_products?: any[] | null;
    image_url?:          string;
    list_name?:          null | string;
    name?:               string;
    price?:              number;
    product_id?:         string;
    products?:           ProductAddedProduct[];
    quantity?:           number;
    sku?:                string;
    url?:                string;
    variant?:            string;
    [property: string]: any;
}

export interface ProductAddedProduct {
    category?:    string;
    description?: string;
    discount?:    number;
    image_url?:   string;
    name?:        string;
    position?:    number;
    price?:       number;
    product_id?:  string;
    quantity?:    number;
    sku?:         string;
    url?:         string;
    variant?:     string;
    [property: string]: any;
}

/**
 * Fires when a user clicks an item in a list
 */
export interface ProductClicked {
    /**
     * Platform the Product was Removed from (website)
     */
    affiliation:   string;
    basket_token?: null | string;
    /**
     * Brand associated with the product
     */
    brand: string;
    /**
     * Product category being viewed
     */
    category?: string;
    /**
     * Coupon code associated with a product (e.g MAP_DROP_2022)
     */
    coupon_name?: any[];
    currency:     string;
    /**
     * Description of Product
     */
    description: string;
    /**
     * Image url of the product
     */
    image_url: string;
    /**
     * Name of Product List Page
     */
    list_name?: string;
    locale?:    string;
    /**
     * Name of the product being viewed
     */
    name: string;
    /**
     * Position in the product list (ex. 3)
     */
    position?: number;
    /**
     * Price of the product being viewed
     */
    price: number;
    /**
     * Database id of the product being viewed
     */
    product_id: string;
    /**
     * Quantity of a product
     */
    quantity?: number;
    /**
     * Sku of the product being viewed
     */
    sku?: string;
    /**
     * URL of the product page
     */
    url: string;
    /**
     * Variant of the product (e.g. Black)
     */
    variant?: string;
    [property: string]: any;
}

/**
 * Fires when a user views a list of products
 */
export interface ProductListViewed {
    basket_token?: null | string;
    /**
     * Product list being viewed
     */
    list_id:    string;
    list_name?: string;
    /**
     * Products displayed in the product list
     */
    products: ProductListViewedProduct[];
    url?:     string;
    [property: string]: any;
}

export interface ProductListViewedProduct {
    affiliation: string;
    brand:       string;
    /**
     * Product category being viewed
     */
    category:     string;
    coupon_name?: any[];
    currency:     string;
    /**
     * Description of Product
     */
    description: string;
    discount?:   number;
    /**
     * Image url of the product
     */
    image_url: string;
    /**
     * Name of the product being viewed
     */
    name: string;
    /**
     * Position in the product list (ex. 3)
     */
    position?: number;
    /**
     * Price ($) of the product being viewed
     */
    price: number;
    /**
     * Product id displayed on the list
     */
    product_id: string;
    /**
     * Quantity of a product
     */
    quantity: number;
    /**
     * Sku of the product being viewed
     */
    sku: string;
    /**
     * URL of the product page
     */
    url: string;
    /**
     * Variant of the product (e.g. Black)
     */
    variant?: string;
    [property: string]: any;
}

/**
 * Fires when a user successfully registers their Traeger product
 */
export interface ProductRegistered {
    email:               string;
    first_name:          string;
    grill_serial_number: string;
    grill_uuid?:         string;
    last_name:           string;
    place?:              string;
    registered_product:  string;
    [property: string]: any;
}

/**
 * Fires when a user removes an item from their cart
 */
export interface ProductRemoved {
    /**
     * Platform the Product was Removed from (website)
     */
    affiliation?: string;
    basket_token: string;
    /**
     * Brand associated with the product
     */
    brand: string;
    /**
     * Product category being viewed
     */
    category?: string;
    /**
     * Coupon code associated with a product (e.g MAY_DROP_2022)
     */
    coupon_name?: any[];
    currency:     string;
    /**
     * Description of Product
     */
    description: string;
    /**
     * Image url of the product
     */
    image_url: string;
    list_name: string;
    /**
     * Name of the product being viewed
     */
    name: string;
    /**
     * Position in the product list (ex. 3)
     */
    position: number;
    /**
     * Price ($) of the product being viewed
     */
    price: number;
    /**
     * Database id of the product being viewed
     */
    product_id: string;
    /**
     * Quantity of a product
     */
    quantity: number;
    /**
     * Sku of the product being viewed
     */
    sku: string;
    /**
     * URL of the product page
     */
    url: string;
    /**
     * Variant of the product (e.g. Black)
     */
    variant?: string;
    [property: string]: any;
}

/**
 * Fires when a user successfully submits a product review onsite
 */
export interface ProductReviewSubmitted {
    nps?:          number;
    product_id?:   string;
    rating?:       number;
    review_body?:  string;
    review_id?:    string;
    review_title?: string;
    [property: string]: any;
}

/**
 * User reviewed a product
 */
export interface ProductReviewed {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fires when a user views a PDP (product detail page)
 */
export interface ProductViewed {
    /**
     * Platform used to view product
     */
    affiliation:   string;
    basket_token?: null | string;
    /**
     * Brand associated with the product
     */
    brand: string;
    /**
     * Product category being viewed
     */
    category?: string;
    /**
     * Coupon code associated with a product (e.g MAP_DROP_2022)
     */
    coupon_name?: any[];
    /**
     * Currency of the transaction
     */
    currency: string;
    /**
     * Product Description
     */
    description: string;
    discount:    number;
    /**
     * Image url of the product
     */
    image_url: string;
    /**
     * Boolean that says if an item is in stock or not
     */
    in_stock?: boolean;
    /**
     * Name of the product being viewed
     */
    name: string;
    /**
     * Price ($) of the product being viewed
     */
    price: number;
    /**
     * Database id of the product being viewed
     */
    product_id: string;
    /**
     * Quantity of a product
     */
    quantity: number;
    /**
     * Sku of the product being viewed
     */
    sku?: string;
    /**
     * URL of the product page
     */
    url?: string;
    /**
     * Variant of the product (e.g. Black)
     */
    variant?: string;
    [property: string]: any;
}

export interface PromotionClicked {
    creative?:   string;
    email?:      string;
    first_name?: string;
    last_name?:  string;
    /**
     * name of promotion
     */
    name?:         string;
    position?:     string;
    promotion_id?: string;
    [property: string]: any;
}

export interface PromotionViewed {
    creative?:   string;
    email?:      string;
    first_name?: string;
    last_name?:  string;
    /**
     * Name of promotion
     */
    name?:         string;
    position?:     string;
    promotion_id?: string;
    [property: string]: any;
}

/**
 * Fires when a user filters a list of recipes
 */
export interface RecipeListFiltered {
    filters: Filter[];
    list_id: string;
    recipes: RecipeListFilteredRecipe[];
    [property: string]: any;
}

export interface Filter {
    complexity?:         string;
    cooking_method?:     string;
    diet?:               string;
    hardwood?:           string;
    holiday?:            string;
    meal_type?:          string;
    related_categories?: string;
    type?:               string;
    value?:              string;
    [property: string]: any;
}

export interface RecipeListFilteredRecipe {
    image_url?: string;
    name?:      string;
    position?:  number;
    recipe_id?: string;
    url?:       string;
    [property: string]: any;
}

/**
 * Fires when a user views a list of recipes
 */
export interface RecipeListViewed {
    /**
     * recipe category page
     */
    list_id: string;
    recipes: RecipeListViewedRecipe[];
    [property: string]: any;
}

export interface RecipeListViewedRecipe {
    image_url: string;
    name:      string;
    position:  number;
    recipe_id: string;
    url:       string;
    [property: string]: any;
}

/**
 * A user adds a note to the recipe
 */
export interface RecipeNoteAdded {
    effort?:                  null | string;
    featured_products:        { [key: string]: any }[] | null;
    note_id?:                 string;
    pellet_recommendation:    null | string;
    recipe_author_name:       string;
    recipe_cook_time:         number | null;
    recipe_id:                string;
    recipe_image_url:         null | string;
    recipe_measurement_units: string;
    recipe_name:              string;
    recipe_prep_time:         number | null;
    recipe_serving_size:      number | null;
    recipe_type?:             string;
    recipe_url:               string;
    [property: string]: any;
}

/**
 * A user deletes a note to the recipe
 */
export interface RecipeNoteDeleted {
    effort?:                  null | string;
    featured_products:        { [key: string]: any }[] | null;
    note_id:                  string;
    pellet_recommendation:    null | string;
    recipe_author_name:       string;
    recipe_cook_time:         number | null;
    recipe_id:                string;
    recipe_image_url:         null | string;
    recipe_measurement_units: string;
    recipe_name:              string;
    recipe_prep_time:         number | null;
    recipe_serving_size:      number | null;
    recipe_type?:             string;
    recipe_url:               string;
    [property: string]: any;
}

/**
 * A user updates a note to the recipe
 */
export interface RecipeNoteUpdated {
    effort?:                  null | string;
    featured_products:        { [key: string]: any }[] | null;
    note_id:                  string;
    pellet_recommendation:    null | string;
    recipe_author_name:       string;
    recipe_cook_time:         number | null;
    recipe_id:                string;
    recipe_image_url:         null | string;
    recipe_measurement_units: string;
    recipe_name:              string;
    recipe_prep_time:         number | null;
    recipe_serving_size:      number | null;
    recipe_type?:             string;
    recipe_url:               string;
    [property: string]: any;
}

/**
 * A user prints a recipe
 */
export interface RecipePrinted {
    effort?:                  null | string;
    featured_products?:       { [key: string]: any }[] | null;
    pellet_recommendation:    null | string;
    recipe_author_name:       null | string;
    recipe_cook_time:         number | null;
    recipe_id:                string;
    recipe_image_url?:        null | string;
    recipe_measurement_units: string;
    recipe_name:              string;
    recipe_prep_time:         number | null;
    recipe_serving_size:      number | null;
    recipe_type?:             string;
    recipe_url:               string;
    [property: string]: any;
}

/**
 * Fires when a user successfully submits a review for a recipe
 */
export interface RecipeReviewSubmitted {
    nps?:          number;
    rating?:       number;
    recipe_id?:    { [key: string]: any };
    review_body?:  string;
    review_id?:    string;
    review_title?: string;
    [property: string]: any;
}

export interface RecipeReviewed {
    email:         string;
    recipe_id:     string;
    review_body:   string;
    review_rating: string;
    review_title:  string;
    [property: string]: any;
}

/**
 * A user shares a recipe
 */
export interface RecipeShared {
    effort?:                  null | string;
    featured_products:        { [key: string]: any }[] | null;
    pellet_recommendation:    null | string;
    recipe_author_name:       null | string;
    recipe_cook_time:         number | null;
    recipe_id:                string;
    recipe_image_url:         null | string;
    recipe_measurement_units: string;
    recipe_name:              string;
    recipe_prep_time:         number | null;
    recipe_serving_size:      number | null;
    recipe_type?:             string;
    recipe_url:               string;
    [property: string]: any;
}

/**
 * A user views a recipe
 */
export interface RecipeViewed {
    /**
     * The difficulty of the recipe
     */
    effort?:              string;
    ingredient_products?: any[];
    /**
     * The type of hardwood the recipe features
     */
    pellet_recommendation: null | string;
    /**
     * The name of the author
     */
    recipe_author_name: string;
    recipe_category?:   any;
    /**
     * the number of minutes this recipe takes
     */
    recipe_cook_time: number | null;
    recipe_duration?: any;
    recipe_holiday?:  any;
    /**
     * The ID of the recipe in the CMS
     */
    recipe_id: string;
    /**
     * Image url of the recipe
     */
    recipe_image_url:  string;
    recipe_meal_type?: any;
    /**
     * The measurement units currently displayed
     */
    recipe_measurment_units: string;
    /**
     * The name of the recipe
     */
    recipe_name: string;
    /**
     * The number of minutes it takes to prep
     */
    recipe_prep_time: number;
    /**
     * The serving size currently displayed
     */
    recipe_serving_size: number;
    /**
     * The type of recipe
     */
    recipe_type?: string;
    /**
     * Recipe url
     */
    recipe_url: string;
    /**
     * Array of products_ids for the products featured in the recipe
     */
    recommended_products?: any[];
    /**
     * Array of shopable ingredients on a recipe page
     */
    shopable_products: any[] | null;
    [property: string]: any;
}

/**
 * Fires when a user lands on a search results page
 */
export interface SearchSubmitted {
    ""?:         { [key: string]: any };
    email?:      string;
    first_name?: string;
    last_name?:  string;
    query?:      string;
    [property: string]: any;
}

/**
 * DO NOT EDIT. Event generated to store end users consent preferences for Unify and Twilio
 * Engage.
 */
export interface SegmentConsentPreferenceUpdated {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fires when a user successfully signs into their account
 */
export interface SignedIn {
    email:      string;
    first_name: string;
    last_name:  string;
    [property: string]: any;
}

export interface ViewedOrderDetails {
    affiliation:      string;
    billing_address:  string;
    billing_city:     string;
    billing_country:  string;
    billing_state:    string;
    billing_zip_code: string;
    brand:            string;
    coupon?:          any[];
    currency:         string;
    discount:         number | null;
    email:            string;
    first_name:       string;
    last_name:        string;
    order_date:       string;
    order_id:         string;
    order_status:     string;
    packages:         number;
    payment_method:   null | string;
    products:         ViewedOrderDetailsProduct[];
    revenue:          number;
    shipping:         number;
    tax:              number;
    total:            number;
    [property: string]: any;
}

export interface ViewedOrderDetailsProduct {
    category:         string;
    description:      string;
    image_url:        string;
    name:             string;
    position:         number;
    product_id:       string;
    quantity:         number;
    shipping_method?: string;
    sku:              string;
    status?:          string;
    url:              string;
    variant?:         string;
    [property: string]: any;
}


/**
 * The analytics.js snippet should be available via window.analytics.
 * You can install it by following instructions at: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 * Make sure to also include the TypeScript declarations with: `npm install @segment/analytics-next` (install with --save-dev for type definitions only).
 *
 * If you don't want to use the snippet, you can also install the `@segment/analytics-next` library as a *production* dependency and use it like this: 
 * ```ts
 * import { AnalyticsBrowser } from '@segment/analytics-next' 
 * import { setTypewriterOptions } from './analytics'
 *
 * const analytics = AnalyticsBrowser.load({ writeKey: 'SEGMENT_WRITE_KEY' })
 * 
 * setTypewriterOptions({ analytics: analytics })
 */
import type { AnalyticsSnippet, Analytics, AnalyticsBrowser, Options } from '@segment/analytics-next'

declare global {
    interface Window {
        analytics: AnalyticsSnippet;
    }
}

type AnyAnalytics = AnalyticsSnippet | Analytics | AnalyticsBrowser

/** The callback exposed by analytics.js. */
export type Callback = () => void

export type ViolationHandler = (
    message: Record<string, any>,
    violations: any[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (message, violations) => {
    const msg = JSON.stringify(
        {
            type: 'Typewriter JSON Schema Validation Error',
            description:
                `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
                'Tracking Plan spec.',
            errors: violations,
        },
        undefined,
        2,
    );

    console.warn(msg);
};


let analytics: () => AnyAnalytics | undefined = () => {
    return window.analytics;
};

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
    /**
     * Underlying analytics instance where analytics calls are forwarded on to.
     * Defaults to window.analytics.
     */
    analytics?: AnyAnalytics;
    /**
     * Handler fired when if an event does not match its spec. This handler
     * does not fire in production mode, because it requires inlining the full
     * JSON Schema spec for each event in your Tracking Plan.
     *
     * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
     * if a message does not match the spec. Otherwise, errors will be logged to stderr.
     */
    onViolation?: ViolationHandler;
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
    analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
}


/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Options = {}): Options {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            typewriter: {
                language: 'typescript',
                version: '9.2.0',
            },
        },
    };
}

/**
 * Fires a 'AccountCreated' track call.
 *
 * @param AccountCreated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function accountCreated(props: AccountCreated, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Account Created', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AccountUpdated' track call.
 *
 * @param AccountUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function accountUpdated(props: AccountUpdated, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Account Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AffirmClicked' track call.
 *
 * @param AffirmClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function affirmClicked(props: AffirmClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Affirm Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CTAClicked' track call.
 *
 * @param CTAClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cTAClicked(props: CTAClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('CTA Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CartViewed' track call.
 *
 * @param CartViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cartViewed(props: CartViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Cart Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutStarted' track call.
 *
 * @param CheckoutStarted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutStarted(props: CheckoutStarted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Checkout Started', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutStepCompleted' track call.
 *
 * @param CheckoutStepCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutStepCompleted(props: CheckoutStepCompleted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Checkout Step Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CheckoutStepViewed' track call.
 *
 * @param CheckoutStepViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function checkoutStepViewed(props: CheckoutStepViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Checkout Step Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CookiePreferencesUpdated' track call.
 *
 * @param CookiePreferencesUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cookiePreferencesUpdated(props: CookiePreferencesUpdated, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Cookie Preferences Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CouponApplied' track call.
 *
 * @param CouponApplied props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function couponApplied(props: CouponApplied, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Coupon Applied', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CouponDenied' track call.
 *
 * @param CouponDenied props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function couponDenied(props: CouponDenied, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Coupon Denied', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CouponRemoved' track call.
 *
 * @param CouponRemoved props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function couponRemoved(props: CouponRemoved, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Coupon Removed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DealerCalled' track call.
 *
 * @param DealerCalled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function dealerCalled(props: DealerCalled, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Dealer Called', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DealerClicked' track call.
 *
 * @param DealerClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function dealerClicked(props: DealerClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Dealer Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DealerDirections' track call.
 *
 * @param DealerDirections props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function dealerDirections(props: DealerDirections, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Dealer Directions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DealerListViewed' track call.
 *
 * @param DealerListViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function dealerListViewed(props: DealerListViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Dealer List Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'EmailClicked' track call.
 *
 * @param EmailClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function emailClicked(props: EmailClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Email Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'EmailOpened' track call.
 *
 * @param EmailOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function emailOpened(props: EmailOpened, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Email Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'EmailSignupCompleted' track call.
 *
 * @param EmailSignupCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function emailSignupCompleted(props: EmailSignupCompleted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Email Signup Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'EmailUnsubscribed' track call.
 *
 * @param EmailUnsubscribed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function emailUnsubscribed(props: EmailUnsubscribed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Email Unsubscribed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'IDmeVerified' track call.
 *
 * @param IDmeVerified props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function iDmeVerified(props: IDmeVerified, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('IDme Verified', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LinkClicked' track call.
 *
 * @param LinkClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function linkClicked(props: LinkClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Link Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NavigationClicked' track call.
 *
 * @param NavigationClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function navigationClicked(props: NavigationClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Navigation Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NotifyMeClicked' track call.
 *
 * @param NotifyMeClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function notifyMeClicked(props: NotifyMeClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Notify Me Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NotifyMeCompleted' track call.
 *
 * @param NotifyMeCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function notifyMeCompleted(props: NotifyMeCompleted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Notify Me Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NotifyMeSend' track call.
 *
 * @param NotifyMeSend props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function notifyMeSend(props: NotifyMeSend, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Notify Me Send', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NotifyMeSubmitted' track call.
 *
 * @param NotifyMeSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function notifyMeSubmitted(props: NotifyMeSubmitted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Notify Me Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'OrderCompleted' track call.
 *
 * @param OrderCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function orderCompleted(props: OrderCompleted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Order Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PageViewed' track call.
 *
 * @param PageViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function pageViewed(props: PageViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Page Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PaymentInfoEntered' track call.
 *
 * @param PaymentInfoEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function paymentInfoEntered(props: PaymentInfoEntered, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Payment Info Entered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductAdded' track call.
 *
 * @param ProductAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productAdded(props: ProductAdded, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Added', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductClicked' track call.
 *
 * @param ProductClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productClicked(props: ProductClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductListViewed' track call.
 *
 * @param ProductListViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productListViewed(props: ProductListViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product List Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductRegistered' track call.
 *
 * @param ProductRegistered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productRegistered(props: ProductRegistered, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Registered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductRemoved' track call.
 *
 * @param ProductRemoved props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productRemoved(props: ProductRemoved, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Removed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductReviewSubmitted' track call.
 *
 * @param ProductReviewSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productReviewSubmitted(props: ProductReviewSubmitted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Review Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductReviewed' track call.
 *
 * @param ProductReviewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productReviewed(props: ProductReviewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Reviewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProductViewed' track call.
 *
 * @param ProductViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function productViewed(props: ProductViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Product Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PromotionClicked' track call.
 *
 * @param PromotionClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function promotionClicked(props: PromotionClicked, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Promotion Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PromotionViewed' track call.
 *
 * @param PromotionViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function promotionViewed(props: PromotionViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Promotion Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeListFiltered' track call.
 *
 * @param RecipeListFiltered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeListFiltered(props: RecipeListFiltered, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe List Filtered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeListViewed' track call.
 *
 * @param RecipeListViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeListViewed(props: RecipeListViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe List Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeNoteAdded' track call.
 *
 * @param RecipeNoteAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeNoteAdded(props: RecipeNoteAdded, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Note Added', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeNoteDeleted' track call.
 *
 * @param RecipeNoteDeleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeNoteDeleted(props: RecipeNoteDeleted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Note Deleted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeNoteUpdated' track call.
 *
 * @param RecipeNoteUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeNoteUpdated(props: RecipeNoteUpdated, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Note Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipePrinted' track call.
 *
 * @param RecipePrinted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipePrinted(props: RecipePrinted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Printed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeReviewSubmitted' track call.
 *
 * @param RecipeReviewSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeReviewSubmitted(props: RecipeReviewSubmitted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Review Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeReviewed' track call.
 *
 * @param RecipeReviewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeReviewed(props: RecipeReviewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Reviewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeShared' track call.
 *
 * @param RecipeShared props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeShared(props: RecipeShared, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Shared', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecipeViewed' track call.
 *
 * @param RecipeViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recipeViewed(props: RecipeViewed, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Recipe Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SearchSubmitted' track call.
 *
 * @param SearchSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function searchSubmitted(props: SearchSubmitted, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Search Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SegmentConsentPreferenceUpdated' track call.
 *
 * @param SegmentConsentPreferenceUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function segmentConsentPreferenceUpdated(props: SegmentConsentPreferenceUpdated, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Segment Consent Preference Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SignedIn' track call.
 *
 * @param SignedIn props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function signedIn(props: SignedIn, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Signed In', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ViewedOrderDetails' track call.
 *
 * @param ViewedOrderDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function viewedOrderDetails(props: ViewedOrderDetails, options?: Options, callback?: Callback): void {


    const a = analytics();
    if (a) {
        a.track('Viewed Order Details', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}

const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,

    /**
     * Fires a 'AccountCreated' track call.
     *
     * @param AccountCreated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    accountCreated,
    /**
     * Fires a 'AccountUpdated' track call.
     *
     * @param AccountUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    accountUpdated,
    /**
     * Fires a 'AffirmClicked' track call.
     *
     * @param AffirmClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    affirmClicked,
    /**
     * Fires a 'CTAClicked' track call.
     *
     * @param CTAClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cTAClicked,
    /**
     * Fires a 'CartViewed' track call.
     *
     * @param CartViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cartViewed,
    /**
     * Fires a 'CheckoutStarted' track call.
     *
     * @param CheckoutStarted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutStarted,
    /**
     * Fires a 'CheckoutStepCompleted' track call.
     *
     * @param CheckoutStepCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutStepCompleted,
    /**
     * Fires a 'CheckoutStepViewed' track call.
     *
     * @param CheckoutStepViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    checkoutStepViewed,
    /**
     * Fires a 'CookiePreferencesUpdated' track call.
     *
     * @param CookiePreferencesUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cookiePreferencesUpdated,
    /**
     * Fires a 'CouponApplied' track call.
     *
     * @param CouponApplied props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    couponApplied,
    /**
     * Fires a 'CouponDenied' track call.
     *
     * @param CouponDenied props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    couponDenied,
    /**
     * Fires a 'CouponRemoved' track call.
     *
     * @param CouponRemoved props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    couponRemoved,
    /**
     * Fires a 'DealerCalled' track call.
     *
     * @param DealerCalled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    dealerCalled,
    /**
     * Fires a 'DealerClicked' track call.
     *
     * @param DealerClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    dealerClicked,
    /**
     * Fires a 'DealerDirections' track call.
     *
     * @param DealerDirections props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    dealerDirections,
    /**
     * Fires a 'DealerListViewed' track call.
     *
     * @param DealerListViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    dealerListViewed,
    /**
     * Fires a 'EmailClicked' track call.
     *
     * @param EmailClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    emailClicked,
    /**
     * Fires a 'EmailOpened' track call.
     *
     * @param EmailOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    emailOpened,
    /**
     * Fires a 'EmailSignupCompleted' track call.
     *
     * @param EmailSignupCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    emailSignupCompleted,
    /**
     * Fires a 'EmailUnsubscribed' track call.
     *
     * @param EmailUnsubscribed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    emailUnsubscribed,
    /**
     * Fires a 'IDmeVerified' track call.
     *
     * @param IDmeVerified props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    iDmeVerified,
    /**
     * Fires a 'LinkClicked' track call.
     *
     * @param LinkClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    linkClicked,
    /**
     * Fires a 'NavigationClicked' track call.
     *
     * @param NavigationClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    navigationClicked,
    /**
     * Fires a 'NotifyMeClicked' track call.
     *
     * @param NotifyMeClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notifyMeClicked,
    /**
     * Fires a 'NotifyMeCompleted' track call.
     *
     * @param NotifyMeCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notifyMeCompleted,
    /**
     * Fires a 'NotifyMeSend' track call.
     *
     * @param NotifyMeSend props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notifyMeSend,
    /**
     * Fires a 'NotifyMeSubmitted' track call.
     *
     * @param NotifyMeSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    notifyMeSubmitted,
    /**
     * Fires a 'OrderCompleted' track call.
     *
     * @param OrderCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    orderCompleted,
    /**
     * Fires a 'PageViewed' track call.
     *
     * @param PageViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageViewed,
    /**
     * Fires a 'PaymentInfoEntered' track call.
     *
     * @param PaymentInfoEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    paymentInfoEntered,
    /**
     * Fires a 'ProductAdded' track call.
     *
     * @param ProductAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productAdded,
    /**
     * Fires a 'ProductClicked' track call.
     *
     * @param ProductClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productClicked,
    /**
     * Fires a 'ProductListViewed' track call.
     *
     * @param ProductListViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productListViewed,
    /**
     * Fires a 'ProductRegistered' track call.
     *
     * @param ProductRegistered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productRegistered,
    /**
     * Fires a 'ProductRemoved' track call.
     *
     * @param ProductRemoved props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productRemoved,
    /**
     * Fires a 'ProductReviewSubmitted' track call.
     *
     * @param ProductReviewSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productReviewSubmitted,
    /**
     * Fires a 'ProductReviewed' track call.
     *
     * @param ProductReviewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productReviewed,
    /**
     * Fires a 'ProductViewed' track call.
     *
     * @param ProductViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    productViewed,
    /**
     * Fires a 'PromotionClicked' track call.
     *
     * @param PromotionClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    promotionClicked,
    /**
     * Fires a 'PromotionViewed' track call.
     *
     * @param PromotionViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    promotionViewed,
    /**
     * Fires a 'RecipeListFiltered' track call.
     *
     * @param RecipeListFiltered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeListFiltered,
    /**
     * Fires a 'RecipeListViewed' track call.
     *
     * @param RecipeListViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeListViewed,
    /**
     * Fires a 'RecipeNoteAdded' track call.
     *
     * @param RecipeNoteAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeNoteAdded,
    /**
     * Fires a 'RecipeNoteDeleted' track call.
     *
     * @param RecipeNoteDeleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeNoteDeleted,
    /**
     * Fires a 'RecipeNoteUpdated' track call.
     *
     * @param RecipeNoteUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeNoteUpdated,
    /**
     * Fires a 'RecipePrinted' track call.
     *
     * @param RecipePrinted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipePrinted,
    /**
     * Fires a 'RecipeReviewSubmitted' track call.
     *
     * @param RecipeReviewSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeReviewSubmitted,
    /**
     * Fires a 'RecipeReviewed' track call.
     *
     * @param RecipeReviewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeReviewed,
    /**
     * Fires a 'RecipeShared' track call.
     *
     * @param RecipeShared props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeShared,
    /**
     * Fires a 'RecipeViewed' track call.
     *
     * @param RecipeViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recipeViewed,
    /**
     * Fires a 'SearchSubmitted' track call.
     *
     * @param SearchSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    searchSubmitted,
    /**
     * Fires a 'SegmentConsentPreferenceUpdated' track call.
     *
     * @param SegmentConsentPreferenceUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    segmentConsentPreferenceUpdated,
    /**
     * Fires a 'SignedIn' track call.
     *
     * @param SignedIn props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signedIn,
    /**
     * Fires a 'ViewedOrderDetails' track call.
     *
     * @param ViewedOrderDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    viewedOrderDetails,
};

export default new Proxy<typeof clientAPI>(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method as keyof typeof clientAPI];
        }

        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
            const a = analytics();
            if (a) {
                a.track(
                    'Unknown Analytics Call Fired',
                    {
                        method,
                    },
                    withTypewriterContext(),
                );
            }
        };
    },
});

